import { useState } from "react";
import {
  Button,
  CircularProgress,
  IconButton,
  Stack,
  ListItemButton,
  ListItemText,
  Typography,
  FormControlLabel,
  Checkbox,
  ListItem,
  Modal,
  Box,
  Card,
  List
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Postrequestcall } from "../../../request/Postrequest";
import { SEND_TIMESHEETS_GOALS } from "../../../constant/Apipath";
import { useSelector, useDispatch } from "react-redux";
import { setShowExport } from "../../../redux/actions/actions";
import { English } from "../../../constant/EnglishFallback";

const ExportGoalsSummaryModal = ({ 
  userGoalData = [], 
  loginData 
}) => {
  const dispatch = useDispatch();
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // ✅ FIXED: Get modal state from Redux
  const { multiLanguageData, showExportModal } = useSelector((state) => state?.main);
  
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    BUTTON_GENERATE = English.TimeSheet.BUTTON_GENERATE,
    TEXT_EXPORT_GOALS_SUMMARY = English.TimeSheet.TEXT_EXPORT_GOALS_SUMMARY,
    TEXT_PLACEHOLDER_NO_DATA = English.TimeSheet.TEXT_PLACEHOLDER_NO_DATA
  } = LanguageData || {};

  // ✅ FIXED: Use Redux action to close modal
  const handleClose = () => {
    if (loading) return; // Prevent closing while loading
    
    setLoading(false);
    setSelectedGoals([]);
    dispatch(setShowExport(false));
  };

  const onGenrateClick = async () => {
    try {
      setLoading(true);
      const pdfObj = {
        Emails: [loginData?.userInformation?.Email],
        Goals: selectedGoals,
        UserId: loginData?.userInformation?.UserId
      };
      
      const response = await Postrequestcall(SEND_TIMESHEETS_GOALS, pdfObj, loginData?.accessToken);
      
      // Check response for better feedback
      if (response?.status === 200 || response?.data?.message === "OK") {
        console.log("Goal summary sent successfully");
      }

      handleClose();
    } catch (err) {
      console.log("onGenrateClick-> Error While Sending Goal Summary: ", err);
    } finally {
      setLoading(false); // Always clear loading state
    }
  };

  const handleCheckboxClick = (item) => {
    if (loading) return; // Prevent interaction while loading
    
    let updatedSelectedGoals;
    if (selectedGoals.includes(item.id)) {
      updatedSelectedGoals = selectedGoals.filter((goalId) => goalId !== item.id);
    } else {
      updatedSelectedGoals = [...selectedGoals, item.id];
    }
    setSelectedGoals(updatedSelectedGoals);
  };

  return (
    <Modal 
      open={showExportModal || false} 
      onClose={loading ? undefined : handleClose}
    >
      <Box className="user-modal-responsive">
        {/* Show loading overlay during generation */}
        {loading && (
          <Box 
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              borderRadius: 1
            }}>
            <CircularProgress size={40} sx={{ color: "#3A75C4" }} />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Generating Goals Summary...
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            opacity: loading ? 0.5 : 1
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_EXPORT_GOALS_SUMMARY}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={handleClose} disabled={loading}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box 
          className="product-list" 
          sx={{ 
            marginTop: "10px",
            opacity: loading ? 0.5 : 1
          }}>
          <List disablePadding>
            {userGoalData.length > 0 ? (
              <Stack sx={{ gap: 1 }} >
                {userGoalData.map((item, index) => {
                  return (
                    <Card 
                      key={index.toString()} 
                      className="pagelist-content"
                      sx={{
                        opacity: loading ? 0.6 : 1,
                        pointerEvents: loading ? 'none' : 'auto'
                      }}>
                      <ListItem
                        onClick={() => handleCheckboxClick(item)}
                        key={index.toString()}
                        disablePadding>
                        <ListItemButton 
                          sx={{ display: "flex", flexDirection: "row" }}
                          disabled={loading}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                checked={selectedGoals.includes(item?.id)}
                                onChange={() => handleCheckboxClick(item)}
                                disabled={loading}
                              />
                            }
                          />
                          <ListItemText>{item?.name?.trim()}</ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Card>
                  );
                })}
              </Stack>
            ) : (
              <Typography sx={{ opacity: loading ? 0.5 : 1 }}>
                {TEXT_PLACEHOLDER_NO_DATA}
              </Typography>
            )}
          </List>
        </Box>

        <Box 
          sx={{ 
            display: "flex", 
            justifyContent: "center", 
            pt: 1,
            opacity: loading ? 0.5 : 1
          }}>
          <Button
            variant="contained"
            onClick={onGenrateClick}
            disabled={!selectedGoals.length || loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}>
            {loading ? "Generating..." : BUTTON_GENERATE}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ExportGoalsSummaryModal;

